let timeout;
let onFrameFns = [];
let onScrollFns = [];

// call all registered functions on animation frame
const onFrame = () => {
    onFrameFns.forEach(fn => fn());
    window.requestAnimationFrame(onFrame);
};

// register scroll and call all registered functions on animation frame
window.addEventListener(
    "scroll",
    function() {
        // If there's a timer, cancel it
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }

        // Setup the new requestAnimationFrame()
        timeout = window.requestAnimationFrame(function() {
            onScrollFns.forEach(fn => fn());
        });
    },
    false
);

window.requestAnimationFrame(onFrame);

export const add = fn => onFrameFns.push(fn);
export const onScroll = fn => {
    fn();
    onScrollFns.push(fn);
};
